module.exports = __webpack_public_path__ + "img/star.942ddb39.svg";